import { ENTITY_ATTRIBUTE_TYPE } from "src/consts/entityAttribute";

/**
 * Get the parsed crop data from the attributes
 * @param {teamform.attributes.BaseEntityAttribute} attributes
 * @returns {object|null}
 */
export const getParsedCropDataFromAttributes = (attributes) => {
  const cropDataString = attributes?.find(
    (attribute) =>
      attribute?.attributeType === ENTITY_ATTRIBUTE_TYPE.IMAGE_CROP_DATA
  )?.value;

  try {
    return JSON.parse(cropDataString);
  } catch (error) {
    return null;
  }
};
